import styled from "styled-components";

const ICON_CONTAINER_BOTTOM_LEFT_POISTION = "-7px";

export const IconContainer = styled.div(({ theme }) => {
    return {
        position: "absolute",
        bottom: ICON_CONTAINER_BOTTOM_LEFT_POISTION,
        right: ICON_CONTAINER_BOTTOM_LEFT_POISTION,
        width: theme.spacing.medium,
        height: theme.spacing.medium,
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: `1px solid ${theme.colors[theme.colorMode].border_Secondary}`,
        overflow: "hidden",
        zIndex: 1,
        clipPath: "polygon(10% 0, 100% 0, 100% 100%, 0 100%, 0 75%, 25% 25%, 70% 0);",
        background: theme.colors.light.background_Primary,
    };
});

export const StyledIcon = styled.img(() => {
    return {
        width: "60%",
        height: "auto",
    };
});
